module.exports = __webpack_public_path__ + "static/media/other.be2c9e30.jpg";